<template>
    <main class="MainCon myborderT bottom0" id="MainCon">
        <div class="mt30" v-show="tabIndex === 1">
            <TopGoodsList :style-name="styleName" :list="list"
                          :is-empty="list.length === 0" />
        </div>

        <div class="mt30" v-show="tabIndex === 2">
            <JdGoodsList :style-name="styleName" :list="list"
                         :is-empty="list.length === 0" />
        </div>

        <div class="mt30" v-show="tabIndex === 3">
            <PddGoodsList :style-name="styleName" :list="list"
                          :is-empty="list.length === 0" />
        </div>
    </main>
</template>

<script>
    import TopGoodsList from './TopGoodsList';
    import JdGoodsList from './JdGoodsList';
    import PddGoodsList from './PddGoodsList';

    export default {
        components: {TopGoodsList, JdGoodsList, PddGoodsList},
        props: {
            styleName: {
                type: String,
                default: 'main'
            },
            tabIndex: {
                type: Number,
                default: 1,
            },
            list: {
                type: Array
            }
        }
    }
</script>

<style scoped>

</style>
